import { render, staticRenderFns } from "./biu-form-item.vue?vue&type=template&id=2805c3ba&"
import script from "./biu-form-item.vue?vue&type=script&lang=ts&"
export * from "./biu-form-item.vue?vue&type=script&lang=ts&"
import style0 from "./biu-form-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports